import styled from 'styled-components';

import { ds } from '@/config/colors';

import { media } from '../../../../utils/mediaQueries';

/* Wysokość paska, z której liczy się wysokość ekranu pod nim (SignIn.styled.ts). */
export const AUTH_TOP_BAR_HEIGHT = 64;
export const AUTH_TOP_BAR_HEIGHT_MOBILE = 56;

/* Pasek górny jak w hotelspot-audit (Header.astro): biały, przyklejony u góry, włos linii pod spodem. */
export const TopBar = styled.header`
  position: sticky;
  top: 0;
  z-index: 50;
  background: ${ds.bgSurface};
  border-bottom: 1px solid ${ds.borderDefault};
`;

/* Logo przy lewej krawędzi kontenera (1440 px, padding 32 px jak hero).
   Gdy ekran jest za wąski i logo wpadłoby pod przycisk powrotu, przesuwa się tuż za niego:
   --auth-back-w to zmierzona szerokość przycisku z odstępem (AuthTopBar.tsx). */
export const TopBarInner = styled.div`
  display: flex;
  align-items: center;
  height: ${AUTH_TOP_BAR_HEIGHT}px;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 32px;

  ${media.mobile} {
    height: ${AUTH_TOP_BAR_HEIGHT_MOBILE}px;
    padding: 0 20px;
  }
`;

export const BrandSlot = styled.div`
  display: flex;
  margin-left: max(0px, calc(var(--auth-back-w, 0px) - max(0px, (100vw - 1440px) / 2) - 32px));

  ${media.mobile} {
    margin-left: auto;
  }
`;

/* Powrót przy lewej krawędzi ekranu, niezależnie od kontenera. */
export const BackSlot = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 12px;
  display: flex;
  align-items: center;
`;

export const BrandLink = styled.a`
  display: inline-flex;
  align-items: center;
  border-radius: 8px;

  svg,
  img {
    height: 28px;
    width: auto;
  }

  &:focus-visible {
    outline: 2px solid ${ds.accentInk};
    outline-offset: 3px;
  }
`;

/* Przycisk drugorzędny z DS: biały, rounded-full, ramka border-default (hover border-strong), min. 44 px. */
export const BackButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 8px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: ${ds.textPrimary};
  text-decoration: none;
  text-underline-offset: 3px;
  border-radius: 8px;

  svg {
    width: 16px;
    height: 16px;
    stroke-width: 1.75;
  }

  &:hover span {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${ds.accentInk};
    outline-offset: 2px;
  }
`;

/* Na telefonie skrócony podpis (sama domena), pełny od tabletu w górę. */
export const BackLabelFull = styled.span`
  ${media.mobile} {
    display: none;
  }
`;

export const BackLabelShort = styled.span`
  display: none;

  ${media.mobile} {
    display: inline;
  }
`;
